import { render, staticRenderFns } from "./UsageFilterChips.vue?vue&type=template&id=1d90e452&"
import script from "./UsageFilterChips.vue?vue&type=script&lang=ts&"
export * from "./UsageFilterChips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports